export default __webpack_public_path__ + "ConsentForm1.html";